module.exports = __webpack_public_path__ + "img/pycharm.a69ddd0b.png";